import { PendingAssetClientInfDto } from "@growth-machine-llc/stridist-api-client";
import { Box, Typography } from "@mui/material";
import React from "react";
import { Avatar } from "../avatar/Avatar";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
  },

  name: {
    fontWeight: "bold",
    lineHeight: "18px",
    fontSize: 15,
  },

  email: {
    fontWeight: 500,
    lineHeight: "18px",
    fontSize: 15,
  },

  textOverflow: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },

  avatar: {
    marginRight: theme.spacing(1),
  },
}));

interface PendingExerciseClientContainerProps {
  client: PendingAssetClientInfDto;
}

const PendingExerciseClientContainer = (
  props: PendingExerciseClientContainerProps,
) => {
  const { client } = props;
  const s = useStyles();

  return (
    <Box className={clsx(s.root)}>
      <Avatar
        photoURL={client?.photoUrl}
        displayName={client?.clientName}
        usePendingExerciseAvatarStyle={true}
        className={s.avatar}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "flex-start",
        }}
      >
        <Typography
          className={clsx(s.name, s.textOverflow)}
          children={client.clientName}
        />
        <Typography
          className={clsx(s.email, s.textOverflow)}
          children={client.email}
        />
      </Box>
    </Box>
  );
};

export default PendingExerciseClientContainer;
